<template lang="pug">
  .component-reservation-log-timeline
    .row
      .column.small-6.large-3.text-center(v-for="(tab,k,i) in tabs", :key="i", )
        ToggleableButton(:selectable="true", :value="tabs[k]", :key="k")
          tooltip(:open="true", :position="'right'", :tip="k").has-tip
            span.fa-2x(:class="getTabIcon(k)", @click="toggle(k)")
            span.badge.success {{getCount(k)}}
    hr
    .row(v-for="(items,key) in timeline")
      .columns
        strong {{key}}
        .row.log(v-for="item in items")
          .time.columns.small-2 {{$date(item.created_at).format('HH:mm:ss')}}
          .separator
            hr
          .icon
            i.fa(:class="getTabIcon(item.user)")
          .column.description
            .user {{item.user}}
            .columns(v-html="item.case")
</template>
<script type="text/babel">


import collect from 'collect.js'
import Tooltip from 'components/structure/foundation/Tooltip'
import ToggleableButton from '../structure/ui/ToggleableButton'

export default {
  name: 'ReservationLogTimeLine',
  components: {ToggleableButton, Tooltip},
  data() {
    return {
      timeline: {},
      groupedTimeline: {},
      activeTab: [],
      tabs: {},
      enabledTabs: []

    }
  },
  created() {
    //this.activeTab = this.items[0].user
    this.items.forEach((item, index) => {
      item.case = this.getDescription(item)
    })
    const groupedTimeline = collect(this.items).groupBy('user')

    groupedTimeline.each((item, k) => {
      this.tabs[k] = true
    })
    this.updateTimeLine()
  },
  methods: {
    toggle(tab) {
      let t = this.tabs
      t[tab] = !t[tab]
      this.tabs = Object.assign({}, t)
      this.updateTimeLine()
    },
    updateTimeLine() {
      const filtered = this.items.filter((item) => {
        return this.tabs[item.user]
      })

      this.timeline = collect(filtered).groupBy((i) => {
        return this.$date(i.created_at).format('DD MMM YYYY')
      }).all()
    },

    getTabIcon(key) {
      let cssClass = ['fa', 'fa-user']

      switch (key) {
        case 'sentinel':
          cssClass = ['fa', 'fa-exclamation-triangle']
          break
        case 'hardware':
          cssClass = ['fa', 'fa-microchip']
          break
        case 'System:0':
          cssClass = ['fa', 'fa-cog']
          break
      }

      return cssClass
    },
    getCount(key) {
      return collect(this.items).groupBy('user').all()[key].length
    },
    getDescription(item) {
      switch (item.case) {
        case 'reservation-immediate-send':
          return 'Reservation triggered immediate send'

        case 'reservation-created':
          return `<div>Reservation <strong>created</strong></div><div>Start: ${this.$dateFormat(item.start, this.$toMomentFormat(this.$configurationDateTimeFormat()))} - End: ${this.$dateFormat(item.end, this.$toMomentFormat(this.$configurationDateTimeFormat()))}</div>`

        case 'send-to-vehicle':
          return 'Reservation has been sent to the vehicle'

        case 'reservation-sent':
          return 'Vehicle has received command'

        case 'convadis-start-received':
          return 'Vehicle has received command'

        case 'reservation-edited':
          return `<div>Reservation <strong>edited</strong></div><div>Start: ${this.$dateFormat(item.start, this.$toMomentFormat(this.$configurationDateTimeFormat()))} - End: ${this.$dateFormat(item.end, this.$toMomentFormat(this.$configurationDateTimeFormat()))}</div>`

        case 'reservation-immediate-send-edit':
          return 'Reservation triggered immediate send edit'

        case'action-teminate-sent':
          return 'Customer has terminated the reservation'

        case 'reservation-completed':
          return 'Reservation end has been sent to the vehicle'

        case 'reservation-unable-to-set-completed-from-COMPLETED':
          return 'Vehicle has received end signal'

        case 'reservation-charged':
          return 'Reservation Charged'

        case'send-edit-to-vehicle':
          return 'Edited reservation received'

        case 'action-close-car-sent':
          return 'Customer has logged out'

        case 'action-open-car-sent':
          return 'Customer has sent pin for open'

        case 'reservation-started':
          return 'Reservation status has changed to: <strong>STARTED</strong>'

        case 'reservation-unable-to-set-started-from-STARTED':
          return 'Customer has logged out'

        case 'reservation-confirmed':
          return 'Reservation status has changed to: <strong>CONFIRMED</strong>'
        default:
          if (item.case.startsWith('SENTINEL')) {
            item.user = 'sentinel'
          }
          if (item.case.startsWith('SENT VH')) {
            item.case = `${item.user} ${item.case}`
            item.user = 'hardware'
          }
          if (item.case.includes('App\\Exceptions')) {
            item.user = 'hardware'
            item.case = `<span class="danger">${item.case}</span>`
          }
          return item.case
      }
    }
  },
  computed: {},
  props: ['items']
}
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-reservation-log-timeline
    .description
      .columns
        padding-left: 0
    .separator
      min-height: 40px
      min-width: 40px
      bottom: 10px
      border-left: 1px solid
      position: relative
      margin-left: 20px
    .danger
      color: red
    .active
      color: #5EB9CF

    .log-headers
      cursor: pointer

    .toggleable-button
      button
        color: #A3A3A3

        &.active
          color: green
          background: white
</style>



// WEBPACK FOOTER //
// ReservationLogTimeLine.vue?1cf4b975